import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSort, faSortUp, faSortDown } from "@fortawesome/free-solid-svg-icons"

const Container = styled.div`
  display: flex;
  align-items: center;
`
const Icon = styled(FontAwesomeIcon)`
  font-size: 1.5rem;
  color: ${(props) => (props.active ? props.theme.colours.active : "#777")};
  cursor: pointer;
`

/**
 * Renders sort chevrons to change the sorting of a table
 */
const SortHeader = ({ sortBy = "", filter = {}, setFilter }) => {
  let desc =
    filter.sort_by == sortBy && filter.sort_order.toUpperCase() == "DESC"
  let asc = filter.sort_by == sortBy && filter.sort_order.toUpperCase() == "ASC"
  return (
    <Container>
      {desc && (
        <Icon
          icon={faSortDown}
          onClick={() =>
            setFilter({
              ...filter,
              sort_order: "ASC",
              sort_by: sortBy,
            })
          }
          title="Click to sort ascending"
          active={"true"}
        />
      )}
      {asc && (
        <Icon
          icon={faSortUp}
          onClick={() =>
            setFilter({
              ...filter,
              sort_order: "DESC",
              sort_by: sortBy,
            })
          }
          title="Click to sort descending"
          active={"true"}
        />
      )}
      {!asc && !desc && (
        <Icon
          icon={faSort}
          onClick={() =>
            setFilter({
              ...filter,
              sort_order: "DESC",
              sort_by: sortBy,
            })
          }
          title="Click to sort by this field"
        />
      )}
    </Container>
  )
}

SortHeader.propTypes = {
  sortBy: PropTypes.string, //  The column name
  filter: PropTypes.object, //  The current filters
  setFilter: PropTypes.func.isRequired, //  The set filter function
}

export default SortHeader
